(function () {
  'use strict';

  function formatCurrency(amount) {
    var rounded = Math.round(amount || 0);
    try {
      return rounded.toLocaleString('fr-FR') + ' €';
    } catch (e) {
      return rounded + ' €';
    }
  }

  function pulse(el, className) {
    if (!el) return;
    el.classList.remove(className);
    void el.offsetWidth; // force reflow so the animation restarts
    el.classList.add(className);
  }

  function initDevisBuilder(root) {
    if (!root || root.dataset.devisReady === 'true') return;
    root.dataset.devisReady = 'true';

    var plafond = parseFloat(root.dataset.plafond) || 0;
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('[data-devis-checkbox]'));
    var totalEl = root.querySelector('[data-devis-total]');
    var selectionField = root.querySelector('[data-devis-selection-field]');
    var totalField = root.querySelector('[data-devis-total-field]');

    if (!checkboxes.length) return;

    function rowFor(checkbox) {
      return checkbox.closest('.devis-brique');
    }

    function priceFor(row) {
      var price = row ? parseFloat(row.dataset.price) : 0;
      return isNaN(price) ? 0 : price;
    }

    function currentTotal() {
      return checkboxes.reduce(function (sum, checkbox) {
        if (!checkbox.checked) return sum;
        return sum + priceFor(rowFor(checkbox));
      }, 0);
    }

    function updateLocks(total) {
      checkboxes.forEach(function (checkbox) {
        var row = rowFor(checkbox);
        if (!row) return;
        var wouldExceed = plafond > 0 && total + priceFor(row) > plafond;
        var lockedMsg = row.querySelector('[data-devis-locked-msg]');

        if (!checkbox.checked && wouldExceed) {
          checkbox.disabled = true;
          row.classList.add('is-disabled');
          if (lockedMsg) lockedMsg.hidden = false;
        } else {
          checkbox.disabled = false;
          row.classList.remove('is-disabled');
          if (lockedMsg) lockedMsg.hidden = true;
        }

        row.classList.toggle('is-checked', checkbox.checked);
      });
    }

    function updateHiddenFields(total) {
      if (selectionField) {
        var selected = checkboxes
          .filter(function (checkbox) {
            return checkbox.checked;
          })
          .map(function (checkbox) {
            var row = rowFor(checkbox);
            var label = row ? row.dataset.label : '';
            return '- ' + label + ' (' + formatCurrency(priceFor(row)) + ')';
          });

        selectionField.value = selected.length
          ? selected.join('\n')
          : 'Aucune brique sélectionnée';
      }

      if (totalField) {
        totalField.value = formatCurrency(total);
      }
    }

    function render() {
      var total = currentTotal();
      if (totalEl) totalEl.textContent = formatCurrency(total);
      updateLocks(total);
      updateHiddenFields(total);
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        pulse(rowFor(checkbox), 'is-pulsing');
        pulse(totalEl, 'is-updating');
        render();
      });
    });

    render();
  }

  function initAll(context) {
    var scope = context && typeof context.querySelectorAll === 'function' ? context : document;
    scope.querySelectorAll('[data-devis-builder]').forEach(initDevisBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  if (!window.__devisBuilderSectionListener) {
    window.__devisBuilderSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
